import React, { createContext, useContext, useState, useCallback } from "react"
interface SidebarContextType {
 isOpen: boolean
 isCollapsed: boolean
 isMobileOpen: boolean
 toggle: () => void
 collapse: () => void
 expand: () => void
 toggleMobile: () => void
 setMobileOpen: (open: boolean) => void
 closeMobile: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export function useSidebar() {
 const context = useContext(SidebarContext)
 if (!context) {
 throw new Error("useSidebar must be used within a SidebarProvider")
 }
 return context
}

interface LayoutProviderProps {
 children: React.ReactNode
}

export function LayoutProvider({ children }: LayoutProviderProps) {
 const [isOpen] = useState(true)
 const [isCollapsed, setIsCollapsed] = useState(false)
 const [isMobileOpen, setIsMobileOpen] = useState(false)

 const toggle = useCallback(() => setIsCollapsed((prev) => !prev), [])
 const collapse = useCallback(() => setIsCollapsed(true), [])
 const expand = useCallback(() => setIsCollapsed(false), [])
 const toggleMobile = useCallback(() => setIsMobileOpen((prev) => !prev), [])
 const setMobileOpen = useCallback((open: boolean) => setIsMobileOpen(open), [])
 const closeMobile = useCallback(() => setIsMobileOpen(false), [])

 return (
 <SidebarContext.Provider
 value={{
 isOpen,
 isCollapsed,
 isMobileOpen,
 toggle,
 collapse,
 expand,
 toggleMobile,
 setMobileOpen,
 closeMobile,
 }}
 >
 {children}
 </SidebarContext.Provider>
 )
}
